/* dace studio – gemeinsames Skript für alle Seiten: Hell/Dunkel, Warenkorb, Einblendungen, Zähler, Kopieren */
(function () {
  const R = document.documentElement;
  R.classList.add("js");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const mqLight = matchMedia("(prefers-color-scheme: light)");
  const store = { get() { try { return localStorage.getItem("dace-theme"); } catch (e) { return null; } }, set(v) { try { localStorage.setItem("dace-theme", v); } catch (e) {} } };
  const mode = () => R.dataset.theme || (mqLight.matches ? "light" : "dark");
  const syncMode = () => { R.dataset.mode = mode(); document.dispatchEvent(new CustomEvent("dace:mode", { detail: mode() })); };
  const saved = store.get();
  if (saved === "light" || saved === "dark") R.dataset.theme = saved;
  const tb = document.getElementById("themeBtn");
  if (tb) tb.addEventListener("click", () => {
    const next = mode() === "light" ? "dark" : "light";
    if ((next === "light") === mqLight.matches) { delete R.dataset.theme; store.set(""); } else { R.dataset.theme = next; store.set(next); }
    syncMode();
  });
  mqLight.addEventListener("change", syncMode);
  syncMode();
  window.dace = { reduce, mode };

  /* Einblenden beim Scrollen (Startzustand sichtbar, nur Elemente unterhalb des Bildschirms) */
  const rvs = [...document.querySelectorAll(".rv")];
  if (!reduce && "IntersectionObserver" in window) {
    rvs.forEach(el => { if (el.getBoundingClientRect().top > innerHeight) el.classList.add("pre"); });
    const rio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.remove("pre"); rio.unobserve(e.target); } }), { rootMargin: "0px 0px -8% 0px" });
    rvs.forEach(el => rio.observe(el));
  }

  /* Hochzählende Zahlen */
  const nio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting || reduce) return;
    nio.unobserve(e.target);
    const el = e.target, end = +el.dataset.count, t0 = performance.now();
    (function tick(t) { const k = Math.min(1, (t - t0) / 1200); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); })(t0);
  }), { threshold: .6 });
  document.querySelectorAll("[data-count]").forEach(n => nio.observe(n));

  /* Warenkorb über die Shopify AJAX API */
  const drawer = document.getElementById("drawer");
  if (drawer) {
    const cur = drawer.dataset.currency || "EUR";
    const MARK = '<svg viewBox="0 0 224 256" aria-hidden="true"><path fill="var(--fg)" d="M128 0A128 128 0 0 0 128 256Z"/><path fill="#e5262c" d="M193.5 185.0L186.8 190.8L179.5 197.8L174.2 203.5L169.8 209.2L167.0 213.5L164.8 218.0L163.5 223.5L163.8 227.2L164.8 231.0L166.8 234.5L169.8 237.5L174.8 240.0L177.2 240.5L181.2 240.5L183.5 240.0L187.8 238.0L190.0 236.0L191.2 234.2L191.5 234.5L190.5 239.5L188.5 244.0L186.0 247.5L182.2 251.0L205.0 251.0L201.8 248.0L198.5 243.5L196.5 238.5L195.8 234.5L196.0 234.2L197.8 236.5L199.2 237.8L203.8 240.0L206.0 240.5L210.0 240.5L214.0 239.5L218.8 236.5L221.5 233.0L223.0 229.8L223.2 228.0L223.8 227.5L223.8 221.5L223.2 221.0L223.0 219.2L220.8 214.2L217.8 209.5L214.5 205.2L209.0 199.0L203.2 193.2L196.0 186.8Z"/></svg>';
    const money = c => (c / 100).toLocaleString("de-DE", { style: "currency", currency: cur });
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
    const note = t => { document.getElementById("note").textContent = t || ""; };
    async function loadCart() {
      try { const r = await fetch("/cart.js", { headers: { Accept: "application/json" } }); if (!r.ok) throw 0; return await r.json(); }
      catch (e) { return { items: [], total_price: 0, item_count: 0 }; }
    }
    function render(cart) {
      document.querySelectorAll("[data-cart-count]").forEach(el => el.textContent = cart.item_count);
      const body = document.getElementById("cartBody");
      body.innerHTML = cart.items.length ? cart.items.map(it => `<div class="line-item"><div class="thumb">${it.image ? `<img src="${esc(it.image)}" alt="">` : MARK}</div><div><div class="li-name">${esc(it.product_title)}</div><div class="li-sub">Digitaler Download · Menge ${it.quantity}</div><button class="rm" type="button" data-key="${esc(it.key)}">Entfernen</button></div><div>${money(it.final_line_price)}</div></div>`).join("")
        : '<p class="empty">Dein Warenkorb ist leer.</p>';
      document.getElementById("sub").textContent = money(cart.total_price);
      document.getElementById("tax").textContent = money(cart.total_price - cart.total_price / 1.19);
      document.getElementById("tot").textContent = money(cart.total_price);
      document.getElementById("checkout").disabled = !cart.item_count;
      body.querySelectorAll(".rm").forEach(b => b.onclick = async () => {
        await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) });
        render(await loadCart());
      });
    }
    function openCart(o) {
      R.classList.toggle("cart-open", o);
      drawer.setAttribute("aria-hidden", String(!o));
      if (o) document.getElementById("cartClose").focus();
    }
    async function add(variant, btn) {
      note("");
      if (!variant) { render(await loadCart()); openCart(true); note("Dieses Produkt ist noch nicht verfügbar."); return; }
      if (btn) btn.disabled = true;
      try {
        const cart = await loadCart();
        if (!cart.items.some(i => String(i.variant_id) === String(variant))) {
          const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +variant, quantity: 1 }] }) });
          if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || "Hinzufügen fehlgeschlagen"); }
        }
        render(await loadCart()); openCart(true);
      } catch (e) { render(await loadCart()); openCart(true); note(e.message + ". Bitte erneut versuchen."); }
      finally { if (btn) btn.disabled = false; }
    }
    document.addEventListener("click", e => { const b = e.target.closest("[data-add]"); if (b) { e.preventDefault(); add(b.dataset.variant, b); } });
    document.querySelectorAll("[data-cart-open]").forEach(b => b.addEventListener("click", async () => { render(await loadCart()); openCart(true); }));
    document.getElementById("cartClose").onclick = () => openCart(false);
    document.getElementById("drawerBg").onclick = () => openCart(false);
    addEventListener("keydown", e => { if (e.key === "Escape") openCart(false); });
    document.getElementById("checkout").onclick = () => { location.href = "/checkout"; };
    loadCart().then(render);
    window.dace.addToCart = add;
  }

  /* E-Mail-Adresse kopieren */
  const mc = document.getElementById("mailCopy");
  if (mc) mc.addEventListener("click", () => {
    const n = document.getElementById("copyNote");
    const sel = () => { const r = document.createRange(); r.selectNodeContents(document.getElementById("mailText")); const s = getSelection(); s.removeAllRanges(); s.addRange(r); n.textContent = "Adresse markiert, jetzt mit Strg+C kopieren."; };
    try { navigator.clipboard.writeText(mc.dataset.mail).then(() => { n.textContent = "Adresse kopiert."; }, sel); } catch (e) { sel(); }
  });
})();
